import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=4fb2a460&"
import script from "./AddressBook.vue?vue&type=script&lang=ts&"
export * from "./AddressBook.vue?vue&type=script&lang=ts&"
import style0 from "./AddressBook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports